import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type SectionHeaderProps = {
  title: string;
  actions?: React.ReactNode;
  className?: string;
  subtitle?: React.ReactNode;
};

export function SectionHeader({ actions, className = 'section-head', subtitle, title }: SectionHeaderProps) {
  return (
    <Box className={className}>
      <div>
        <Typography component="h2" variant="h2">{title}</Typography>
        {subtitle ? <span>{subtitle}</span> : null}
      </div>
      {actions ? <div className="section-actions">{actions}</div> : null}
    </Box>
  );
}
